import * as React from "react";
import { css } from "@emotion/react";
import { borderRadius } from "main/javascripts/styles/base/borderStyle";

export interface IProps {
  youtubeLink: string;
}

export const LpCruiseYouTubeVideo: React.FC<IProps> = (
  props: IProps
): React.ReactElement => {
  const { youtubeLink } = props;

  // YouTube URLからビデオIDを抽出
  const getYoutubeVideoId = (url: string): string => {
    const match =
      /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/.exec(url);
    return match?.[2] ?? "";
  };

  const videoId = getYoutubeVideoId(youtubeLink);

  return (
    <div css={videoBlockStyle}>
      <iframe
        css={videoStyle}
        src={`https://www.youtube-nocookie.com/embed/${videoId}`}
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
};

const videoBlockStyle = css`
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
`;

const videoStyle = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: ${borderRadius.message};
`;
